module.exports = __webpack_public_path__ + "img/bankgirot-primary-small.6a76a25f.png";